//本地代理 发布环境['-test','-uat',' ']
let ENV = ''

let NowApiDianDian=''
let NowApiCms=''
let NowApiDurex=''

switch (ENV) {
    case '-test':
        if(process.env.NODE_ENV=='development'){
            //dev
            NowApiDianDian='http://127.0.0.1:8087/diandian'
            NowApiCms='http://127.0.0.1:8087/ddcms'
            NowApiDurex='http://127.0.0.1:8087/durex'
        }else{
            //test
            NowApiDianDian='https://diandian-test2.zhongan.com/noah/apiAction.do'
            NowApiCms='https://dd-cms-test.zhongan.com/apiAction.do'
            NowApiDurex='https://aucen-test.zhongan.com'
            // NowApiDurex='http://fcp-bt-za-fin-auth-service.test.za.biz'

        }
        break;
    case '-uat':
        NowApiDianDian='https://diandian-mics-uat.zhongan.com/apiAction.do'
        NowApiCms='https://cms-uat.zhongan.com/apiAction.do'
        NowApiDurex='https://aucen-uat.zhongan.com'
        break;
    case '':
        NowApiDianDian='https://finance.diandian.com.cn/apiAction.do'
        NowApiCms='https://cms.diandian.com.cn/apiAction.do'
        NowApiDurex='https://aucen.zhongan.com'
        break;
}

module.exports = {
    ENV: ENV,
    API_ROOT: NowApiDianDian,
    API_CMS: NowApiCms,
    API_DUREX: NowApiDurex
}

// module.exports = {
//     ENV: ENV,
//     API_ROOT: process.env.NODE_ENV !== 'production' ?
//         'http://127.0.0.1:8087/diandian' : 'https://diandian' + ENV + '.zhongan.com/apiAction.do',
//     API_CMS: process.env.NODE_ENV !== 'production' ?
//         'http://127.0.0.1:8087/ddcms' : 'https://cms' + ENV + '.zhongan.com/apiAction.do'
// }



// WEBPACK FOOTER //
// ./src/config.js